import { Box, Button, Collapse, ListItemButton, ListItemText, useTheme, Popover, Typography, lighten, IconButton } from "@mui/material"
import { Feature } from 'geojson'
import "./ListView.scss"
import { IMapData, IMapLayer } from "../../../../shared/models/map_models"
import MapDataCard from "../MapDataCard/MapDataCard"
import { Loader } from "../../../../shared/components"
import { useState } from "react"
import { ArrowForward, ExpandLess, ExpandMore } from "@mui/icons-material"
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface IListViewProps {
    features: Array<Feature>,
    layer: IMapLayer | null,
    loading: boolean,
    cardSelected: (mapData: IMapData, layer: IMapLayer, cardIndex: number, goTo: boolean) => void
    activeCardIndex?: number | null,
    listViewOptions?: Array<IMapLayer>
    listViewSelected?: (id: number) => void
    cardIconClicked?: () => void
    minimizeList: boolean
    toggleMinimize: () => void
}


const ListView = (props: IListViewProps) => {

    const theme = useTheme()

    const [expand, setExpand] = useState(false)
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const handleMapCardClick = (feature: Feature, index: number, goToItem = false) => {
        if(feature.properties?.data && props.layer)
            props.cardSelected(feature.properties.data, props.layer, index, goToItem)
    }

    const toggleExpand = () => {
        if(!expand){
            const el = document.getElementById('list-title-wrapper')
            setAnchorEl(el)
        } else {
            setAnchorEl(null)
        }
        setExpand(!expand)
    }

    const handleListViewPopupClicked = (layerId: number) => {
        if (props.listViewSelected){
            props.listViewSelected(layerId)
            setExpand(!expand)
        }
    }
    return (
        <Box 
            sx={{background: theme.palette.secondary.dark}} 
            className={`list-view-wrapper hide-scrollbar ${props.minimizeList ? 'minimized-list-view' : 'maximized-list-view'}`}
        >
            {!props.minimizeList ?
                <>
                    <Box 
                        sx={{color: theme.palette.info.main, backgroundColor: theme.palette.secondary.dark}} 
                        className="list-title" 
                        id="list-title-wrapper"
                    >
                        {props.listViewOptions ?
                            <>
                                <ListItemButton onClick={toggleExpand}>
                                    <ListItemText
                                        sx={{color: props.layer?.visible ? theme.palette.info.main : theme.palette.secondary.main}} 
                                        primary={props.layer?.name + " Results"} 
                                        secondary={props.features.length + " records found"}
                                    />
                                    {expand ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <IconButton onClick={props.toggleMinimize} sx={{padding: 0, margin: "2px"}}>
                                    <ArrowBackIcon color='info' />
                                </IconButton>
                                <Collapse in={expand} timeout="auto" unmountOnExit>
                                    <Popover
                                        open={expand}
                                        anchorEl={anchorEl}
                                        onClose={toggleExpand}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'center',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'center',
                                        }}
                                    >
                                        <div className="list-view-options-wrapper">
                                            {props.listViewOptions.map((layer) =>
                                                <Button
                                                    variant="text"
                                                    sx={{flex: 1, margin: "2px", textTransform: 'none', color: theme.palette.info.main, zIndex: 0}}
                                                    disabled={!layer.visible || !layer.detailed_view_configs}
                                                    onClick={() => handleListViewPopupClicked(layer.id)}
                                                >
                                                    {layer.name}
                                                </Button>
                                            )}
                                        </div>
                                    </Popover>
                                </Collapse>
                            </>
                        :
                            <>{props.layer?.name} Results</>
                        }
                    </Box>
                    {props.loading ?
                        <div className="loading-wrapper">
                            <Loader />
                        </div>
                    :
                        <>
                            {props.layer && props.layer.detailed_view_configs && props.features.map((feature, i) => 
                                <Button 
                                    className={"map-card-button-wrapper"} 
                                    variant="text" 
                                    key={i}
                                    onClick={() => handleMapCardClick(feature, i)}
                                >
                                    <MapDataCard 
                                        feature={feature} 
                                        layer={props.layer!} 
                                        isActive={props.activeCardIndex === i}
                                        iconClicked={() => handleMapCardClick(feature, i, true)}
                                    />
                                    <Box sx={{border: `1px solid ${theme.palette.custom.border}`}}></Box>
                                </Button>
                            )}
                            {!props.layer?.visible &&
                                <Box sx={{padding: "25px"}}>
                                    This layer has been hidden, click the the checkbox in the layer dropdown to view this data
                                </Box>
                            }
                            {props.layer?.visible && props.layer?.detailed_view_configs && props.features.length === 0 &&
                                <Box sx={{padding: "25px"}}>
                                    No data found, try adjusting filters or searching in a different area
                                </Box>
                            }
                        </>
                    }
                </>
            :
                <IconButton onClick={props.toggleMinimize}>
                    <ArrowForward color='info' />
                </IconButton>
            }
        </Box>
    )
}

export default ListView